export const siteInfo = {
  name: '久久视频',
  tagline: '高清视频在线观看平台',
  description: '久久视频是您的高清视频在线观看首选平台，汇聚海量影视、综艺、短视频内容，流畅播放体验，随时随地畅享精彩视频世界。',
  url: 'https://jiujiu.video',
  logo: '久久视频',
  foundingYear: 2020,
  email: 'contact@jiujiu.video',
  phone: '400-888-9999',
  address: '北京市朝阳区建国路88号SOHO现代城A座15层',
  socialLinks: {
    weibo: 'https://weibo.com/jiujiuvideo',
    wechat: '久久视频',
    douyin: '@久久视频',
  },
};

export const aboutContent = {
  brandIntro: {
    title: '品牌介绍',
    sections: [
      {
        heading: '关于久久视频',
        content: '久久视频成立于2020年，是国内领先的高清视频在线观看平台。我们致力于为用户提供丰富、优质、流畅的视频观看体验，涵盖电影、电视剧、综艺、动漫、纪录片、短视频等多元内容。经过多年的发展，久久视频已经成为数千万用户信赖的视频平台。',
      },
      {
        heading: '我们的使命',
        content: '让每一次观看都成为享受。久久视频坚持"内容为王、体验至上"的理念，不断优化产品功能，丰富内容生态，为用户打造最舒适的视频观看环境。我们相信，好的内容值得被更多人看到，而好的平台应该让发现好内容变得简单。',
      },
      {
        heading: '核心技术',
        content: '久久视频拥有自主研发的视频编码和分发技术，支持4K超高清画质和流畅的在线播放体验。我们的智能推荐系统能够精准理解用户偏好，为每一位用户提供个性化的内容推荐。同时，我们持续投入技术研发，确保平台的安全性和稳定性。',
      },
    ],
  },
  reputation: {
    title: '口碑见证',
    stats: [
      { value: '5000万+', label: '累计用户' },
      { value: '99.7%', label: '服务可用率' },
      { value: '4.8分', label: '用户综合评分' },
      { value: '200+', label: '合作伙伴' },
    ],
    testimonials: [
      {
        quote: '久久视频的内容质量一直很稳定，更新也很快，是我每天必刷的平台。推荐算法也很准，经常能发现一些意想不到的好内容。',
        author: '张先生',
        role: '资深用户 · 使用3年',
      },
      {
        quote: '作为内容创作者，久久视频给了我们很好的展示平台。流量分配公平，收益模式透明，是值得信赖的合作伙伴。',
        author: '李女士',
        role: '视频创作者',
      },
      {
        quote: '画质清晰流畅，界面简洁好用，没有乱七八糟的广告，用户体验做得非常好。已经推荐给了身边很多朋友。',
        author: '王同学',
        role: '大学生用户',
      },
      {
        quote: '合作三年了，久久视频的团队专业高效，对内容的理解和把控都很到位。是行业内难得的良心平台。',
        author: '赵总',
        role: '内容合作方',
      },
    ],
  },
  contact: {
    title: '联系我们',
    description: '如果您有任何问题、建议或合作意向，欢迎通过以下方式与我们取得联系。我们的团队将在24小时内回复您的咨询。',
    email: 'contact@jiujiu.video',
    phone: '400-888-9999',
    address: '北京市朝阳区建国路88号SOHO现代城A座15层',
    workingHours: '周一至周五 9:00 - 18:00',
  },
};

export const faqItems = [
  {
    question: '久久视频是否需要付费观看？',
    answer: '久久视频提供大量免费内容供用户观看。同时，我们也提供VIP会员服务，会员可以享受无广告、超清画质、独家内容等特权。您可以根据自己的需求选择合适的观看方式。',
  },
  {
    question: '如何下载久久视频APP？',
    answer: '您可以在苹果App Store或各大安卓应用市场搜索"久久视频"下载官方APP。也可以在久久视频官网扫描二维码直接下载。我们建议通过官方渠道下载，以确保账号安全。',
  },
  {
    question: '久久视频支持哪些设备观看？',
    answer: '久久视频支持在多种设备上观看，包括手机（iOS和Android）、平板电脑、电脑（网页版）以及智能电视。您可以在不同设备间无缝切换，享受一致的观看体验。',
  },
  {
    question: '视频播放卡顿怎么办？',
    answer: '如果您在观看视频时遇到卡顿，建议尝试以下方法：1）检查网络连接是否正常；2）尝试降低视频画质；3）清理浏览器或APP缓存；4）切换网络环境。如果问题仍然存在，请联系客服获取帮助。',
  },
  {
    question: '如何成为久久视频的内容创作者？',
    answer: '我们欢迎所有热爱视频创作的朋友加入久久视频创作者大家庭。您可以在久久视频官网或APP中找到"创作者中心"入口，按照指引完成注册和认证流程。审核通过后即可开始上传内容。',
  },
];